import { Routes } from '@angular/router';
import { MainLearnItemComponent } from './content/main-learn-item/main-learn-item.component';
import { MainConsumerComponent } from './consumer/main-consumer/main-consumer.component';
import { MainEditorComponent } from './editor/main-editor/main-editor.component';
import { authGuard } from './core/guards/auth.guard';
import { LoginComponent } from './login/login.component';
import { MainSubjectComponent } from './subject/main-subject/main-subject.component';
import { FunctionalHelpComponent } from './functionalHelp/main-functionalHelp/functional-help/functional-help.component';
import { ExamComponent } from './lesson/exam/main-exam/exam/exam.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ExerciseComponent } from './lesson/exercise/main-exercise/exercise.component';
import { ExplanationComponent } from './explanation/main-explanation/main-explanation/explanation.component';
import { MainGlobalMetadataComponent } from './global-metadata/main-global-metadata/main-global-metadata.component';
import { StyleguideComponent } from './dev-area/styleguide/styleguide.component';
import { environment } from '../environments/environment';
import { MainLearningSectionComponent } from './learning-section/main-learning-section/main-learning-section.component';
import { LearningUnitMainComponent } from './learning-unit/learning-unit-main/learning-unit-main.component';
import { MainModuleComponent } from './module/main-module/main-module.component';
import { ExamSequenceMainComponent } from './sequence/exam/exam-sequence-main/exam-sequence-main.component';
import {
  ExerciseSequenceMainComponent
} from './sequence/exercise/exercise-sequence-main/exercise-sequence-main.component';
import { ModuleTableComponent } from './dev-area/module-table/module-table.component';
import { ApiDocumentationComponent } from './dev-area/api-documentation/api-documentation.component';
import { MainTestComponent } from './test/main-test/main-test.component';
import { MainProductComponent } from './product/main-product/main-product.component';
import { MainGenericTreeComponent } from './generic-tree/main-generic-tree/main-generic-tree.component';
import { MainFeedbackComponent } from './feedback/main-feedback/feedback.component';

export let appRoutes: Routes = [

  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [authGuard],
    data: {
      breadcrumb: 'Dashboard',
      label: 'Dashboard',
      icon: 'dashboard',
      visible: true,
    }
  },
  {
    path: 'lerninhalte',
    canActivate: [authGuard],
    data: {
      breadcrumb: 'Lerninhalte',
      label: 'Lerninhalte',
      icon: 'category',
      visible: true,
    },
    children: [
      {
        path: 'sequenzen',
        canActivate: [authGuard],
        data: {
          breadcrumb: 'Sequenzen',
          label: 'Sequenzen',
          icon: 'directions_walk',
          visible: true,
        },
        children: [
          {
            path: 'examSequence',
            component: ExamSequenceMainComponent,
            canActivate: [authGuard],
            data: {
              breadcrumb: 'Testsequenzen',
              label: 'Testsequenzen',
              icon: 'snowshoeing',
              visible: true,
            }
          },
          {
            path: 'exerciseSequence',
            component: ExerciseSequenceMainComponent,
            canActivate: [authGuard],
            data: {
              breadcrumb: 'Übungssequenzen',
              label: 'Übungssequenzen',
              icon: 'sports_gymnastics',
              visible: true,
            }
          },
        ]
      },
      {
        path: 'aufgaben',
        canActivate: [authGuard],
        data: {
          breadcrumb: 'Aufgaben',
          label: 'Aufgaben',
          icon: 'cast_for_education',
          visible: true,
        },
        children: [
          {
            path: 'exam',
            component: ExamComponent,
            canActivate: [authGuard],
            data: {
              breadcrumb: 'Testaufgaben',
              label: 'Testaufgaben',
              icon: 'quiz',
              visible: true,
            }
          },
          {
            path: 'exercise',
            component: ExerciseComponent,
            canActivate: [authGuard],
            data: {
              breadcrumb: 'Übungsaufgaben',
              label: 'Übungsaufgaben',
              icon: 'edit_square',
              visible: true,
            }
          },
        ]
      },
      {
        path: 'explanation',
        component: ExplanationComponent,
        canActivate: [authGuard],
        data: {
          breadcrumb: 'Erklärungen',
          label: 'Erklärungen',
          icon: 'privacy_tip',
          visible: true,
        }
      },
      {
        path: 'test',
        component: MainTestComponent,
        canActivate: [authGuard],
        data: {
          breadcrumb: 'Tests',
          label: 'Tests',
          icon: 'detection_and_zone',
          visible: true,
        }
      },
      {
        path: 'feedback',
        component: MainFeedbackComponent,
        canActivate: [authGuard],
        data: {
          breadcrumb: 'Rückmeldungen',
          label: 'Rückmeldungen',
          icon: 'feedback',
          visible: true,
        }
      },
      {
        path: 'functionalHelp',
        component: FunctionalHelpComponent,
        canActivate: [authGuard],
        data: {
          breadcrumb: 'Funktionale Hilfe/Tipps',
          label: 'Funktionale Hilfe/Tipps',
          icon: 'help_center',
          visible: true,
        }
      },
      {
        path: 'dig-lernmodule',
        canActivate: [authGuard],
        data: {
          breadcrumb: 'Dig. Lernmodule',
          label: 'Dig. Lernmodule',
          icon: 'gradient',
          visible: true,
        },
        children: [
          {
            path: 'modules',
            component: MainModuleComponent,
            canActivate: [authGuard],
            data: {
              breadcrumb: 'Module',
              label: 'Module',
              icon: 'view_module',
              visible: true,
            }
          },
          {
            path: 'learning-units',
            component: LearningUnitMainComponent,
            canActivate: [authGuard],
            data: {
              breadcrumb: 'Lerneinheiten',
              label: 'Lerneinheiten',
              icon: 'layers',
              visible: true,
            }
          },
          {
            path: 'learning-sections',
            component: MainLearningSectionComponent,
            canActivate: [authGuard],
            data: {
              breadcrumb: 'Lernabschnitte',
              label: 'Lernabschnitte',
              icon: 'line_style',
              visible: true,
            }
          },
        ]
      },
    ]
  },
  {
    path: 'learnItems',
    component: MainLearnItemComponent,
    canActivate: [authGuard],
    data: {
      breadcrumb: 'Lerninhalte',
    }
  },
  {
    path: 'consumers',
    component: MainConsumerComponent,
    canActivate: [authGuard],
    data: {
      breadcrumb: 'Konsumenten',
      label: 'Konsumenten',
      icon: 'web_asset',
      visible: true,
      roles: ['zavAdmin']
    }
  },
  {
    path: 'products',
    component: MainProductComponent,
    canActivate: [authGuard],
    data: {
      breadcrumb: 'Produktdaten',
      label: 'Produktdaten',
      icon: 'add_shopping_cart',
      visible: true,
      roles: ['editor', 'appAdmin', 'zavAdmin']
    }
  },
  {
    path: 'global-metadata',
    component: MainGlobalMetadataComponent,
    canActivate: [authGuard],
    data: {
      breadcrumb: 'Globale Metadaten',
      label: 'Globale Metadaten',
      icon: 'public',
      visible: true,
      roles: ['zavAdmin']
    }
  },
  {
    path: 'editors',
    component: MainEditorComponent,
    canActivate: [authGuard],
    data: {
      breadcrumb: 'Benutzer',
      label: 'Benutzer',
      icon: 'group',
      visible: true,
      roles: ['zavAdmin']
    }
  },
  {
    path: 'generic-trees',
    component: MainGenericTreeComponent,
    canActivate: [authGuard],
    data: {
      breadcrumb: 'Generische Bäume',
      label: 'Generische Bäume',
      icon: 'account_tree',
      visible: true,
      roles: ['editor', 'appAdmin', 'zavAdmin']
    }
  },
  {
    path: 'subjects',
    component: MainSubjectComponent,
    canActivate: [authGuard],
    data: {
      breadcrumb: 'Fächer/Berufe',
      label: 'Fächer/Berufe',
      icon: 'work',
      visible: true,
      roles: ['zavAdmin']
    }
  },
];

const devAreaChildren: Routes = [
  ...(environment.isLocal ?
    [
      {
        path: 'styleguide',
        component: StyleguideComponent,
        canActivate: [authGuard],
        data: {
          breadcrumb: 'Styleguide',
          label: 'Styleguide',
          icon: 'info',
          visible: true
        }
      },
      {
        path: 'entity-state-table',
        component: ModuleTableComponent,
        data: {
          breadcrumb: 'Entity State Table',
          label: 'Entity State Table',
          icon: 'storage',
          visible: true
        }
      }
    ] :
    []),
  {
    path: 'apidocumentation',
    component: ApiDocumentationComponent,
    canActivate: [authGuard],
    data: {
      breadcrumb: 'Api-Doku',
      label: 'Api-Doku',
      icon: 'bigtop_updates',
      visible: true,
      roles: ['zavAdmin']
    }
  }
];

const devRoutes: Routes = [
  {
    path: 'separator-dev-area',
    redirectTo: '/dashboard',
    pathMatch: 'full',
    data: {
      isSeparator: true,
      visible: true,
      roles: ['zavAdmin']
    }
  },
  {
    path: 'dev-area',
    canActivate: [authGuard],
    data: {
      breadcrumb: 'Dev-Bereich',
      label: 'Dev-Bereich',
      icon: 'code',
      visible: true,
      roles: ['zavAdmin']
    },
    children: devAreaChildren
  }
];

appRoutes = [...appRoutes, ...devRoutes];
